// UN4RT: Fix für Produkte mit ausschließlich "size"-Option
// Zeigt nach dem Laden das Hauptbild (erstes nicht-Varianten-Bild) im Viewer

(function () {
  function isSizeOnlyProduct() {
    const variantSelects = document.querySelector('variant-selects');
    if (!variantSelects) return false;
    const options = variantSelects.querySelectorAll('fieldset legend, .product-form__input label');
    // Prüfe ob nur "size" als Option existiert (kein "color", "colour", "farbe")
    const colorKeywords = ['color', 'colour', 'farbe', 'colour'];
    const allInputGroups = variantSelects.querySelectorAll('fieldset, .product-form__input--dropdown');
    for (const group of allInputGroups) {
      const label = group.querySelector('legend, label')?.textContent?.toLowerCase().trim() || '';
      if (colorKeywords.some(k => label.includes(k))) return false;
    }
    return allInputGroups.length > 0;
  }

  function fixGallery() {
    if (!isSizeOnlyProduct()) return;

    const mediaGallery = document.querySelector('media-gallery');
    if (!mediaGallery) return;

    const viewerUl = mediaGallery.querySelector('.product__media-list');
    const thumbnailUl = mediaGallery.querySelector('.thumbnail-list');
    if (!viewerUl) return;

    const allViewerItems = Array.from(viewerUl.querySelectorAll('li[data-media-id]'));
    if (allViewerItems.length < 2) return;

    // Finde das aktive (Varianten/Größen) li und das erste nicht-aktive (Hauptbild) li
    const activeItem = allViewerItems.find(li => li.classList.contains('is-active'));
    const mainItem = allViewerItems.find(li => !li.classList.contains('is-active'));

    if (!activeItem || !mainItem) return;

    // Hauptbild: is-active setzen, Größenbild: is-active entfernen
    activeItem.classList.remove('is-active');
    mainItem.classList.add('is-active');

    // Viewer scrollen zum Hauptbild (es ist bereits im DOM an richtiger Position)
    const sliderComponent = mediaGallery.querySelector('#GalleryViewer-' + mediaGallery.id.replace('MediaGallery-', ''));
    if (sliderComponent && sliderComponent.slider) {
      sliderComponent.slider.scrollTo({ left: mainItem.offsetLeft, behavior: 'instant' });
    } else {
      // Fallback: direkt scrollen
      viewerUl.scrollTo({ left: mainItem.offsetLeft, behavior: 'instant' });
    }

    // Thumbnails: aria-current korrigieren
    if (thumbnailUl) {
      const mainMediaId = mainItem.dataset.mediaId;
      thumbnailUl.querySelectorAll('button[aria-current="true"]').forEach(btn => btn.removeAttribute('aria-current'));
      const mainThumb = thumbnailUl.querySelector(`[data-target="${mainMediaId}"] button`);
      if (mainThumb) mainThumb.setAttribute('aria-current', 'true');
    }
  }

  // Nach DOMContentLoaded + kurzer Verzögerung (Dawn initialisiert nach load)
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => setTimeout(fixGallery, 50));
  } else {
    setTimeout(fixGallery, 50);
  }
})();
